/**
 * service-mail weight-adjustments client. Mirrors:
 *   apps/service-mail/src/modules/mail-weight/mail-weight.controller.ts
 *
 * RBAC: Mail/submitWeightAdjustment for both submit and list.
 */
import { env } from '../env';

import { request } from './client';

export type WeightAdjustmentStatus = 'AUTO_APPLIED' | 'PENDING_APPROVAL' | 'APPROVED' | 'REJECTED';

export interface WeightAdjustmentDto {
  readonly id: string;
  readonly mailItemId: string;
  readonly trackingNumber: string;
  readonly declaredWeightGrams: number;
  readonly scannedWeightGrams: number;
  readonly deltaGrams: number;
   
  readonly feeDeltaMinor: number;
  readonly priceTariffId: string | null;
  readonly operatorId: string;
  readonly status: WeightAdjustmentStatus;
  readonly supervisorRequestId: string | null;
  readonly createdAt: string;
  readonly updatedAt: string;
}

export interface ListWeightAdjustmentsResponse {
  readonly items: readonly WeightAdjustmentDto[];
  // eslint-disable-next-line upmp/no-number-money -- row count
  readonly total: number;
  readonly page: number;
  readonly pageSize: number;
}

export interface SubmitWeightAdjustmentBody {
  readonly scannedWeightGrams: number;
   
  readonly feeDeltaMinor: number;
  readonly priceTariffId?: string;
}

const baseUrl = (): string => env.serviceMailBaseUrl;

export async function submitWeightAdjustment(
  mailItemId: string,
  body: SubmitWeightAdjustmentBody,
): Promise<WeightAdjustmentDto> {
  return request<WeightAdjustmentDto>(baseUrl(), `/v1/mail-items/${mailItemId}/weight-adjustments`, {
    method: 'POST',
    body,
  });
}

export async function listWeightAdjustments(query: {
  status?: WeightAdjustmentStatus;
  page?: number;
  pageSize?: number;
} = {}): Promise<ListWeightAdjustmentsResponse> {
  return request<ListWeightAdjustmentsResponse>(baseUrl(), '/v1/weight-adjustments', {
    method: 'GET',
    query: {
      status: query.status,
      page: query.page,
      pageSize: query.pageSize,
    },
  });
}
